export class ShipmentReceiver {
  name: string
  country: string | any
  postalCode: string
  city: string
  street1: string
  phone: string
  email: string
  mobile: string
  contact: string
  houseNumber: string

  address?: string

  constructor(
    name: string,
    country: string,
    postalCode: string,
    city: string,
    street1: string,
    phone: string,
    email: string,
    mobile: string,
    contact: string,
    houseNumber: string,

    address?: string

  ) {
    this.name = name
    this.country = country
    this.postalCode = postalCode
    this.city = city
    this.street1 = street1
    this.phone = phone
    this.email = email
    this.mobile = mobile
    this.contact = contact
    this.houseNumber = houseNumber

    this.address = address
  }
}
